export enum CookieConsentType {
    REQUIRED = 'required_storage',
    AD = 'ad_storage',
    FUNCTIONALITY = 'functionality_storage',
    PERSONALIZATION = 'personalization_storage',
    STATISTICS = 'statistics_storage',
    SECURITY = 'security_storage',
}
